<template>
  <date-time-picker
    v-bind="pickerConfig"
    :id="inputId"
    ref="picker"
    v-model="innerValue"
    :disabled="disabled"
    :button-now-translation="strings.date_time.now"
    no-value-to-custom-elem
  >
    <div class="datetime-group" @click.stop>
      <input
        :id="inputId"
        ref="input"
        :placeholder="placeholderText"
        :disabled="disabled"
        :value="dateFormatted()"
        type="text"
        class="form-control"
        @click.stop
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      />
      <button
        v-if="!isEmpty"
        class="btn text-primary font-weight-bold datetime-clear"
        type="button"
        @click.stop="clear"
      >
        &cross;
      </button>
    </div>
  </date-time-picker>
</template>

<script>
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import baseConfig from '../stylemix-base/config'
import strings from '../stylemix-base/strings'

export default {
  name: 'NightThresholdTimeInput',

  components: {
    DateTimePicker: VueCtkDateTimePicker,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: () => `night-time-${Math.random().toString(36).slice(2)}`,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    strings,
    inputManual: false,
  }),

  computed: {
    pickerConfig() {
      return {
        autoClose: false,
        noHeader: true,
        noKeyboard: true,
        onlyTime: true,
        formatted: 'HH:mm',
        format: 'HH:mm',
        outputFormat: 'HH:mm',
        locale: baseConfig.locale,
      }
    },
    innerValue: {
      get() {
        return this.normalizeIncoming(this.value)
      },
      set(v) {
        this.$emit('input', this.normalizeOutgoing(v))
      },
    },
    isEmpty() {
      return !this.value
    },
    placeholderText() {
      return this.placeholder || strings.date_time.select_time
    },
  },

  mounted() {
    this.$forceUpdate()
  },

  methods: {
    normalizeIncoming(v) {
      if (v == null || v === '') {
        return null
      }
      if (typeof v === 'string') {
        const m = moment(v, ['HH:mm', 'HH:mm:ss'], true)
        return m.isValid() ? m.format('HH:mm') : v
      }
      return v
    },
    normalizeOutgoing(v) {
      if (v == null || v === '') {
        return ''
      }
      if (typeof v === 'string') {
        const m = moment(v, ['HH:mm', 'HH:mm:ss', this.pickerConfig.outputFormat], true)
        return m.isValid() ? m.format('HH:mm') : ''
      }
      return ''
    },
    onInput() {
      this.inputManual = true
    },
    onFocus() {
      this.$refs.picker.toggleDatePicker(true)
    },
    onBlur(event) {
      if (this.inputManual) {
        this.tryUpdateValue()
        this.inputManual = false
      }
      const agenda = this.$refs.picker.$refs.agenda
      if (!agenda || !agenda.$el) {
        this.$refs.picker.toggleDatePicker(false)
        return
      }
      const isOurTarget = agenda.$el.contains(event.relatedTarget)
      if (!isOurTarget) {
        this.$refs.picker.toggleDatePicker(false)
      }
    },
    clear() {
      this.$refs.picker.$emit('input', null)
    },
    dateFormatted() {
      return this.$refs.picker ? this.$refs.picker.dateFormatted : null
    },
    tryUpdateValue() {
      let value = null
      if (this.$refs.input.value) {
        value = moment(this.$refs.input.value, this.pickerConfig.formatted)
        if (value.isValid()) {
          value = value.format(this.pickerConfig.outputFormat)
        } else {
          value = null
        }
      }
      this.$refs.picker.$emit('input', value)
    },
  },
}
</script>

<style scoped>
.datetime-group {
  position: relative;
}
.datetime-group .form-control {
  padding-right: 38px;
}
.datetime-clear {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
